var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplaySmallCustomFunnel = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.02 7.076h3.21a1.628 1.628 0 0 0-1.606-1.33c-.789 0-1.465.56-1.605 1.33z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.142 17.604c.036.066.051.142.045.217v2.533l3.559 1.941v-4.474a.434.434 0 0 1 .078-.217l3.98-6.268H2.196l3.945 6.268z",
    fill: "#1E2969"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6C760",
    d: "M1.691 10.537H14.31L16 7.875H0z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#9A5238",
    cx: 10.066,
    cy: 1.618,
    rx: 1.632,
    ry: 1.618
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.135 4.652c0-.894-.73-1.618-1.632-1.618-.901 0-1.632.724-1.632 1.618 0 .893.73 1.618 1.632 1.618.901-.001 1.631-.725 1.632-1.618z",
    fill: "#9A5238"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#1B7690",
    cx: 8.032,
    cy: 24.236,
    rx: 1.779,
    ry: 1.764
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplaySmallCustomFunnel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-small-custom-funnel.12a68e0f52010d2115e47b44f8210217.svg";